"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _index = require("../../index");
var _userTag = require("./userTag.styles");
function UserTag(_ref) {
  let {
    name,
    apmid,
    onRemoveTag
  } = _ref;
  return (0, _jsxRuntime.jsxs)(_userTag.Tag, (0, _extends2["default"])({
    onClick: () => onRemoveTag(apmid)
  }, {
    children: [(0, _jsxRuntime.jsx)(_userTag.Content, {
      children: (0, _jsxRuntime.jsxs)(_userTag.Name, {
        children: [name, (0, _jsxRuntime.jsxs)("span", {
          children: ["(", apmid, ")"]
        })]
      })
    }), (0, _jsxRuntime.jsx)(_userTag.CloseIcon, {
      children: (0, _jsxRuntime.jsx)(_index.Icon, {
        size: "20",
        name: "times-circle"
      })
    })]
  }));
}
var _default = exports["default"] = UserTag;